module.exports = __webpack_public_path__ + "static/media/shopping-cart-empty.07c7d9e0.svg";